const CONFIG: any = {
  http: {
    baseURL: 'https://api.linedrive.emzsoftware.com',
    lineDriveService: 'https://api.linedrive.emzsoftware.com',
    'expense-manager': 'http://vendonexpense-env.eba-uvyg2apk.us-east-2.elasticbeanstalk.com',
  },
};

export default CONFIG;
